const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/_user/profile/edit/general.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
export const Route = createFileRoute("/_authenticated/_feature_announcement/_user/profile/edit/general")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Edit Profile",
      description: "Page title for the edit profile path"
    })
  }
});